import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommissioningRequestDtoModel } from '@bo-client/activation-management/shared/models/commissioningRequestDto';
import {
  CommissioningStatus,
  CommonStatusEnum
} from '@bo-client/activation-management/shared/models/commissioningModel';

export interface CommissioningDeleteModalData {
  commissioningRequest: Pick<CommissioningRequestDtoModel, 'state' | 'actions'>;
}

/**
 * Bestätigungsdialog zum Löschen einer Inbetriebnahme. Schließt mit `true`, wenn das Löschen
 * bestätigt wurde, sonst mit `false`.
 *
 * Ist die Inbetriebnahme eingereicht (Status außerhalb von Entwurf, Fehler und Abgebrochen) und
 * hängt mindestens ein Gerät an einer Netzanmeldung, zeigt der Dialog einen Warnhinweis: Solange
 * eine eingereichte Inbetriebnahme besteht, läuft eine §14a-Netzanmeldung nicht ab. Die
 * Statusliste entspricht `GridRegistrationServiceImpl.COMMISSIONING_STATES_WITHOUT_REQUEST` in
 * netz-services.
 */
@Component({
  selector: 'app-commissioning-delete-modal',
  templateUrl: './commissioning-delete-modal.component.html',
  styleUrls: ['./commissioning-delete-modal.component.scss']
})
export class CommissioningDeleteModalComponent {
  readonly showP14aWarning: boolean;

  constructor(
    private readonly dialogRef: MatDialogRef<CommissioningDeleteModalComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) data: CommissioningDeleteModalData
  ) {
    const commissioningRequest = data?.commissioningRequest;
    const submitted =
      !!commissioningRequest?.state &&
      ![CommonStatusEnum.Incomplete, CommonStatusEnum.Error, CommissioningStatus.Cancelled].includes(
        commissioningRequest.state as CommonStatusEnum | CommissioningStatus
      );
    const linkedToGridRegistration = (commissioningRequest?.actions ?? []).some((action) =>
      (action?.devices ?? []).some((device) => device?.gridRegistration?.id != null)
    );
    this.showP14aWarning = submitted && linkedToGridRegistration;
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
